export default function SendToColleagueComponent(props) {
  return<div>SendToColleagueComponent</div>;
}
